import { nanoid } from 'nanoid'
import type { IHandOfToHumanCallingActionPayload } from 'entities/AICalling/api/types.ts'
import { type IAgentHandoffNotifySettings } from 'entities/Chatbot'

export const createHandOfToHumanCallingAction = (
  data: IAgentHandoffNotifySettings,
  token_id?: string
): IHandOfToHumanCallingActionPayload => {
  return {
    action_type: 'hand_of_to_human',
    trigger_type: 'during_call',
    settings: {
      token_id: token_id ?? nanoid(),
      ...data,
    },
  }
}
